import { useCallback } from 'react';
import { divideQuotas } from 'lib/criterionQuotaUtils';

const colors = ['blue', 'green', 'accent', 'yellow', 'red', 'purple'];

const hashIdToNumber = (id: string): number => {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash << 5) - hash + id.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const getColorForElement = (id: string): string => {
  const index = hashIdToNumber(id) % colors.length;
  return colors[index];
};

export const useOnClickAddQuotas = ({
  hasQuotas,
  selected,
  allOptions,
  setFieldValue,
  numberOfParticipantRequired = 0,
  categoriesFieldName,
  quotasFieldName,
}: {
  hasQuotas: boolean;
  selected: [];
  allOptions: { [key: string]: string };
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  numberOfParticipantRequired: number;
  categoriesFieldName: string;
  quotasFieldName: string;
}) => {
  return useCallback(() => {
    if (hasQuotas) {
      setFieldValue(quotasFieldName, []);
      return;
    }

    if (selected.length === 0) {
      const allValues = Object.values(allOptions);
      setFieldValue(categoriesFieldName, allValues);

      const divided = divideQuotas(
        numberOfParticipantRequired ?? 0,
        allValues.length,
      );
      const initialValues = allValues.map((v: string) => {
        const value = divided.shift() ?? 0;

        return {
          item: v,
          value: value,
          max: value,
        };
      });
      setFieldValue(quotasFieldName, initialValues);
      return;
    }

    if (selected.length > 0) {
      const divided = divideQuotas(
        numberOfParticipantRequired ?? 0,
        selected?.length ?? 0,
      );
      const initialValues = selected.map((v: string) => ({
        item: v,
        max: divided.shift() ?? 0,
      }));
      setFieldValue(quotasFieldName, initialValues);
    }
  }, [
    allOptions,
    hasQuotas,
    numberOfParticipantRequired,
    selected,
    setFieldValue,
    categoriesFieldName,
    quotasFieldName,
  ]);
};
